export default {
  showLoader({ commit }, text) {
    commit('showLoader', text);
  },
  hideLoader({ commit }) {
    commit('hideLoader');
  },
};
